import React, { useEffect } from "react";
import { FaUsers, FaChalkboardTeacher, FaBan, FaHandsHelping, FaChild, FaTools, FaFemale, FaLeaf, FaBook } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "./OurMission.css";

const missions = [
  { id: 1, text: "Making community leaders self-reliant", icon: <FaUsers /> },
  { id: 2, text: "Awareness training program on social issues", icon: <FaChalkboardTeacher /> },
  { id: 3, text: "Awareness program on drug eradication", icon: <FaBan /> },
  { id: 4, text: "Awareness program towards cleanliness", icon: <FaLeaf /> },
  { id: 5, text: "Making women and children literate", icon: <FaChild /> },
  { id: 6, text: "Distribution of relief material among flood and earthquake affected people", icon: <FaHandsHelping /> },
  { id: 7, text: "Providing assistance to orphans and widows", icon: <FaBook /> },
  { id: 8, text: "Organization of skill development training camp for youth", icon: <FaTools /> },
  { id: 9, text: "Seminar or awareness seminar on women empowerment", icon: <FaFemale /> },
  { id: 10, text: "The organization's decision to stop or end the dowry system and child marriage", icon: <FaBan /> },
];

const OurMission = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true, easing: "ease-out-cubic" });
  }, []);

  return (
    <section className="mission-section-home">
      <div className="mission-container-home">
        <h2 className="mission-title-home" data-aos="fade-up">
          Our <span>Mission</span>
        </h2>
        <div className="mission-grid-home">
          {missions.map((mission, index) => (
            <div
              className="mission-card-home"
              key={mission.id}
              data-aos="fade-up"
              data-aos-delay={index * 100} // staggered reveal
            >
              <div className="mission-icon-home">{mission.icon}</div>
              <p className="mission-text-home">{mission.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurMission;
